import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import LoadingSpinner from "../../LoadingSpinner";
import { FORMS, MODULES } from "../../../const";
import Input from "../../input/Input";
import Dropdown from "../../input/Dropdown";
import { getBulkDropdownData, getDropdownData } from "../../../api/keyvalue";
import InfoList from "../../InfoList";
import { formatFromJsonDate } from "../../../dateConfig";
import { User } from "react-feather";
import { blackListValidation } from "../../validations/BlackListCreation";
import { shiftDetailsValidation } from "../../validations/ShiftCreation";
import useUserCompany from "../../../hooks/useUserCompany";

const FORM = FORMS.CALL_CENTER_SHIFT.SHIFT.form;
const ShiftMasterForm = forwardRef(
  ({ errors, dropdown, isLoading, currentValues, editMode }, ref) => {
    const userCompany = useUserCompany();

    const [company, setCompany] = useState(
      userCompany ? userCompany.comId : null,
    );

    useEffect(() => {
      setCompany(userCompany ? userCompany.comId : null);
    }, [userCompany]);

    const [shiftDetailsData, setShiftDetailsData] = useState(
      editMode
        ? {
            ...currentValues,
          }
        : {
            shiCode: "",
            shiReferance: "",
            shiCompany: company,
            shiShift: "",
            shiStart: "",
            shiEnd: "",
            shiDescription: "",
            shiStatus: 2,
            shiActive: 1,
          },
    );

    const [initialActive, setInitialActive] = useState(
      editMode ? currentValues?.shiActive : 1,
    );

    //dropdown
    const [activeOptions, setActiveOptions] = useState([]);
    const [statusOptions, setStatusOptions] = useState([]);

    //bool
    const [searchFieldReset, setSearchFieldReset] = useState(false);

    useEffect(() => {
      (async () => {
        //new
        const { active, status } = await getBulkDropdownData([
          { key: "active" },
          { key: "status" },
        ]);

        setActiveOptions(active);
        setStatusOptions(status);
      })();
    }, []);
    const [currentErrors, setCurrentErrors] = useState({});
    useEffect(() => {
      setCurrentErrors(errors);
    }, [errors]);

    useImperativeHandle(ref, () => ({
      getData: () => shiftDetailsData,
      // validateForm: () => {
      //     return shiftDetailsValidation(shiftDetailsData);
      // },
      isDeletedActive: () =>
        shiftDetailsData.shiActive === 2 && initialActive !== 2,
      resetForm: () => {
        setShiftDetailsData({
          shiCode: "",
          shiReferance: "",
          shiCompany: "",
          shiShift: "",
          shiStart: "",
          shiEnd: "",
          shiDescription: "",
          shiStatus: 2,
          shiActive: 1,
        });
        setSearchFieldReset(true);
        setCurrentErrors({});
      },
    }));
    return (
      <>
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <form
            className="ui form"
            style={{ overflowY: "auto", height: "75vh" }}
          >
            <div className="ui segment">
              <h4 className="ui dividing header">Shift</h4>
              <div className="two fields">
                <Input
                  label="Shift Code"
                  error={currentErrors.shiCode}
                  module={MODULES.Master}
                  form={FORM}
                  field="shi_code"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { shiCode: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="shiCode"
                  value={shiftDetailsData.shiCode}
                  onChange={(e) => {
                    setShiftDetailsData((prevState) => ({
                      ...prevState,
                      shiCode: e.target.value,
                    }));
                  }}
                  disabled={true}
                />
                <Input
                  label="Reference"
                  error={currentErrors.shiReferance}
                  module={MODULES.Master}
                  form={FORM}
                  field="shi_referance"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { shiReferance: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="shiCode"
                  value={shiftDetailsData.shiReferance}
                  onChange={(e) => {
                    setShiftDetailsData((prevState) => ({
                      ...prevState,
                      shiReferance: e.target.value,
                    }));
                  }}
                  disabled={true}
                />
              </div>
              <div className="two fields">
                <Input
                  required={true}
                  label="Shift Name"
                  error={currentErrors.shiShift}
                  module={MODULES.Master}
                  form={FORM}
                  field="shi_shift"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { shiShift: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Shift Name"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                  value={shiftDetailsData.shiShift}
                  onChange={(e) => {
                    setShiftDetailsData((prevState) => ({
                      ...prevState,
                      shiShift: e.target.value,
                    }));
                  }}
                />
              </div>
              <div className="two fields">
                <Input
                  type="time"
                  required={true}
                  label="Start Time"
                  error={currentErrors.shiStart}
                  module={MODULES.Master}
                  form={FORM}
                  editMode={editMode}
                  value={shiftDetailsData.shiStart}
                  onChange={(e) => {
                    setShiftDetailsData((prevState) => ({
                      ...prevState,
                      shiStart: e.target.value,
                    }));
                  }}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { shiStart: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  icon="clock"
                />
                <Input
                  type="time"
                  required={true}
                  label="End Time"
                  error={currentErrors.shiEnd}
                  module={MODULES.Master}
                  form={FORM}
                  editMode={editMode}
                  value={shiftDetailsData.shiEnd}
                  onChange={(e) => {
                    setShiftDetailsData((prevState) => ({
                      ...prevState,
                      shiEnd: e.target.value,
                    }));
                  }}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { shiEnd: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  icon="clock"
                />
              </div>
              <div className="two fields">
                <Input
                  label="Description"
                  error={currentErrors.shiDescription}
                  module={MODULES.Master}
                  form={FORM}
                  field="shi_description"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { shiDescription: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Description"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                  value={shiftDetailsData.shiDescription}
                  onChange={(e) => {
                    setShiftDetailsData((prevState) => ({
                      ...prevState,
                      shiDescription: e.target.value,
                    }));
                  }}
                />
              </div>
              <div className="two fields">
                <Dropdown
                  required={true}
                  label="Status"
                  error={currentErrors.shiStatus}
                  module={MODULES.Master}
                  form={FORM}
                  field="blk_status"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { shiStatus: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Status"
                  options={statusOptions}
                  value={shiftDetailsData.shiStatus}
                  style={{ height: "20px" }}
                  onChange={(e, data) => {
                    setShiftDetailsData((prevState) => ({
                      ...prevState,
                      shiStatus: data.value,
                    }));
                  }}
                />

                <Dropdown
                  required={true}
                  label="Active"
                  error={currentErrors.shiActive}
                  module={MODULES.Master}
                  form={FORM}
                  field="blk_active"
                  // authenticated={true}
                  needDeletePermission={true}
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { shiActive: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Active"
                  options={activeOptions}
                  value={shiftDetailsData.shiActive}
                  style={{ height: "20px" }}
                  onChange={(e, data) => {
                    setShiftDetailsData((prevState) => ({
                      ...prevState,
                      shiActive: data.value,
                    }));
                  }}
                />
              </div>
            </div>
            {editMode && (
              <InfoList
                title="User Information"
                content={[
                  {
                    title: "Created By",
                    value: shiftDetailsData.createdBy
                      ? shiftDetailsData.createdBy
                      : "N/A",
                  },
                  {
                    title: "Created Date",
                    value: shiftDetailsData.createdDate
                      ? formatFromJsonDate(shiftDetailsData.createdDate)
                      : "N/A",
                  },
                  {
                    title: "Last Modified By",
                    value: shiftDetailsData.lastModifiedBy
                      ? shiftDetailsData.lastModifiedBy
                      : "N/A",
                  },
                  {
                    title: "Last Modified Date",
                    value: shiftDetailsData.lastModifiedDate
                      ? formatFromJsonDate(shiftDetailsData.lastModifiedDate)
                      : "N/A",
                  },
                ]}
                Icon={User}
              />
            )}
          </form>
        )}
      </>
    );
  },
);

export default ShiftMasterForm;
